import React, { useEffect, useState } from 'react';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import useFetch from 'CustomHooks/useFetch';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from "@material-ui/core/styles";

export default function OpenOrderLine(props) {

    const { orderItem } = props;
    const { order } = props;
    const [checkState, setCheckState] = useState(true);
    const [setStateOfItemHookResponse, setStateOfItemHook] = useFetch();
    const classes = useStyles();

    useEffect(
        () => {
            setCheckState((orderItem.status == 'Served') ? true : false);
            //console.log(orderItem.status);
        }, []
    )

    const checkboxStateChanged = (e) => {
        setCheckState(e.target.checked);
        console.log(e.target.checked);
        setStateOfItemHook(
            {
                url: `/admin/orders/${order.id}/${orderItem.orderItemId}`,
                addTokenHeader: true,
                method: 'PUT',
                postData: {
                    orderStatus: e.target.checked ? 'Served' : 'Preparing',
                },
            }
        );
    }

    const getOptionPriceTotal = (optionGroups) => {
        let total = 0;
        optionGroups.map(
            optionGroup => optionGroup.options.map(
                option =>
                    total += option.price * option.itemCount
            )
        )
        return total;
    }

    return (
        <React.Fragment>
            <tr key={orderItem.orderItemId}>
                <td>
                    {orderItem.foodOrDrink}
                </td>
                <td>
                    {(orderItem.itemAmount + getOptionPriceTotal(orderItem.itemOptionGroups)).toFixed(2)}
                </td>
                <td>
                    <Checkbox className={classes.checkbox} checked={checkState} onChange={checkboxStateChanged} color="primary" inputProps={{ 'aria-label': 'secondary checkbox' }} />
                </td>
            </tr>
            <tr key={orderItem.orderItemId + '_'}>
                <td align="right" colSpan={3}>
                    {
                        orderItem.itemOptionGroups.map(
                            optionGroup =>
                                optionGroup.options.length > 0 ?
                                    <div key={optionGroup.optionGroupId}>
                                        {props.optionGroups.filter(optGrp => optGrp.id == optionGroup.optionGroupId)[0].optionGroupName}
                                        <div>
                                            {optionGroup.options.map(
                                                (option, index) =>
                                                    <div key={option.optionName}>+ {option.itemCount > 1 ? option.itemCount + 'x ' : ' '} {option.optionName}</div>
                                            )}
                                        </div>
                                    </div>
                                    : null
                        )
                    }
                </td>
            </tr>
        </React.Fragment>
    )
}

const useStyles = makeStyles({
  
    checkbox: {
      padding: '2px 9px',
    },
  

  
  });